import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// style, icons
import { styles } from '../damUseWater/style';

const useStyles = makeStyles(styles);

export default function RiskAreaProvince(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas, currentArea } = props;

  return (
    <>
      <Box className={classes.boxContent} p={1}>
        <Typography variant="h6">
          {t('ขอบเขตพื้นที่ประกาศภัย')}
        </Typography>

        <ul>
          {orderBy(datas.filter((d) => {
            if (currentArea.code !== '0') {
              return d.province_code === currentArea.code.toString();
            }
            return datas;
          }), ['province_name', 'amphoe_name'], ['asc'])
            .map((d) => (
              <li key={d.id}>
                {`${t('จ.')}${d.province_name} ${t('อ.')}${d.amphoe_name} ${t('ต.')}${d.tambon_name} `}
              </li>
            ))}
        </ul>
      </Box>
    </>
  );
}

RiskAreaProvince.propTypes = {
  currentArea: PropTypes.instanceOf(Object).isRequired,
  datas: PropTypes.instanceOf(Object).isRequired,
};
